module.exports = __webpack_public_path__ + "static/media/kcc-short-introduction-cn-new.3a8edd07.mp4";